import { render, staticRenderFns } from "./FloorEditor.vue?vue&type=template&id=37e9e3c4&"
import script from "./FloorEditor.vue?vue&type=script&lang=ts&"
export * from "./FloorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports